import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackViewCartParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackViewCart";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";

const useTrackViewCart = (
    parameters: PartialSpecific<TrackViewCartParameters, "items"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    const hookParameters: TrackViewCartParameters = {
        ...ga.use.eventListParameters(options),
        ...parameters,
    };

    const hookOptions: Toolkit.GoogleAnalytics.Options = {
        promotions: ga.use.promotions(options),
        cart: ga.use.cart(options, true),
        ...options,
    };

    return (parameters: Partial<TrackViewCartParameters> = {}, options?: Toolkit.GoogleAnalytics.Options) => {
        return ga.track.viewCart({ ...hookParameters, ...parameters }, { ...hookOptions, ...options });
    };
};

export default useTrackViewCart;
